// extracted by mini-css-extract-plugin
export default {"container":"info_container__JGXun","item":"info_item__mKJ9q","name":"info_name__9pw+Z","introduction":"info_introduction__v+S2O","introductionItem":"info_introductionItem__yCw-M"};